import { useState } from 'react';

const useAlphaNumericInput = (maxLength = 15, callback) => {
  const [value] = useState('');

  const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'];

  const onKeyDown = (e) => {
    const isAlphaNumeric = /^[a-zA-Z0-9]$/.test(e.key);

    // Prevent spaces (including macOS double-space period behavior)
    if (e.key === ' ') {
      e.preventDefault();
      return;
    }

    // Block invalid characters
    if (!isAlphaNumeric && !allowedKeys.includes(e.key)) {
      e.preventDefault();
      return;
    }

    // Prevent input if max length is reached
    if (value.length >= maxLength && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };
  const onInput = (e) => {
    if (e.target instanceof HTMLInputElement) {
      // Remove any non-alphanumeric characters (excluding lowercase)
      const cleanedValue = e.target.value.replaceAll(/[^a-zA-Z0-9]/g, '');

      // If the value changed after cleaning, update the input
      if (cleanedValue !== e.target.value) {
        e.target.value = cleanedValue;
      }
    }
  };

  const onPaste = (e) => {
    e.preventDefault(); // Prevent default pasting behavior

    const pastedText = e.clipboardData.getData('text');
    const sanitizedText = pastedText.replaceAll(/[^a-zA-Z0-9]/g, '').slice(0, maxLength);

    if (e.currentTarget instanceof HTMLInputElement) {
     callback(sanitizedText)
    }
  };

  return { onKeyDown, onInput, onPaste };
};

export default useAlphaNumericInput;
